import compareVersions from './compareVersions';

export function decideUpdate({ protocolVersion, currentVersion, latestStable }) {
  const method = protocolVersion >= 2 ? 'ota' : 'usb';
  const needsUpdate =
    !!latestStable &&
    !!currentVersion &&
    compareVersions(currentVersion, latestStable) < 0;
  const reason = needsUpdate
    ? `Update available: ${currentVersion} → ${latestStable}`
    : 'Sensor is up to date';
  return { needsUpdate, method, reason };
}
